import { UrlSubdirectoryTypes } from "features/searchResultsFacets";

function getTrackerName() {
  const nhsTrackingId = 'UA-40843711-4';
  const trackers = window.ga.getAll().filter((element) => element.get('trackingId') === nhsTrackingId);
  const tracker = trackers[0].get('name');
  return tracker;
}

function getTrackerClientId() {
  const nhsTrackingId = 'UA-40843711-4';
  const trackers = window.ga.getAll().filter((element) => element.get('trackingId') === nhsTrackingId);
  const clientId = trackers[0].get('clientId');
  return clientId
}

/**
 * A function that returns a value the page type to be track in Google Analytics custom dimensions.
 * for instance, in Homes searches it will return `Home_Results`, in Single Family cases `Single_Family_Homes`.
 */
const getPageType = (page) => UrlSubdirectoryTypes.fromKey(page)?.pageType || '';

export { getTrackerName, getPageType, getTrackerClientId };
